import { Promise } from 'es6-promise';
import { Strings } from "./Stores/StringsStore";
import * as Utilities from "./Utilities";

function HtmlRequest(url: string): Promise<string> {

	return new Promise<string>((resolve: (result: string) => void, reject: (error: string) => void) => {
		try {
			let startTime = Utilities.stopWatch();
			let xhr: XMLHttpRequest = new XMLHttpRequest();
			xhr.onreadystatechange = function (ev: ProgressEvent): any {
				if (xhr.readyState == 4) {

					let timeTaken = Utilities.stopWatch(startTime);

					if (xhr.status == 200) {
						let result: string = xhr.responseText == "" ? "" : xhr.responseText;

						Utilities.DebugLog(`HtmlRequest time: ${timeTaken}ms apiUrl: ${url}`);
						resolve(result);
					}
					else {
						Utilities.DebugLog(`HtmlRequest time: ${timeTaken}ms apiUrl: ${url}  failed with status: ${xhr.status} message: ${xhr.responseText}`);
						if (xhr.status == 400) {
							reject(xhr.responseText);
						}
						else if (xhr.status == 401) {
							reject(Strings.general.sessionTimeoutErrorMessage);
						}
						else {
							reject("error");
						}
					}
				}
			};
			xhr.open("POST", url, true);
			xhr.setRequestHeader("Content-Type", "text/plain");
			xhr.send();
		}
		catch (e) {
			reject("general error");
		}
	});
}


export function GetHtml(url: string): Promise<string> {
	return HtmlRequest(url);
}